import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propBool, propFunc, propShape, propStr, } from '../../../../../helpers/custom-prop-types';
import HtmlLink from '../../../Common/HtmlLink';
import Image from '../../../Common/Image';
import Hover from '../../../System/Hover';
import SlideSearchSlideItemFooter from '../Common/SlideSearchSlideItemFooter';
import SlideSearchShareItemMembers from './Parts/SlideSearchShareItemMembers';
import SlideSearchShareItemStatus from './Parts/SlideSearchShareItemStatus';
/**
 * 共有したスライドの情報を表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchShareItem = (props) => {
    var _a, _b;
    const { className, isNoLink, item, onClickNoLink } = props;
    const { count, createdAt, id, members, slides } = item;
    const isNoLinkComponent = useMemo(() => {
        if (isNoLink) {
            return 'div';
        }
        if (onClickNoLink) {
            return 'button';
        }
        return undefined;
    }, [onClickNoLink, isNoLink]);
    return (_jsx(Hover, { children: _jsx(HtmlLink, Object.assign({ className: clsx('slide_search_share_item', isNoLink && 'no-link', className), isNoLinkComponent: isNoLinkComponent, onClickNoLink: onClickNoLink, to: `/proffit_search/share_history/${id}` }, { children: _jsxs("div", Object.assign({ className: 'item_inner' }, { children: [_jsx("div", Object.assign({ className: 'item_left' }, { children: _jsx("div", Object.assign({ className: 'left_inner' }, { children: _jsx(Image, { allowContextMenu: false, alt: '', className: ((_a = slides[0]) === null || _a === void 0 ? void 0 : _a.image) ? 'left_thumbnail' : '', isObjectFit: true, src: ((_b = slides[0]) === null || _b === void 0 ? void 0 : _b.image) || '', useImage: true }) })) })), _jsxs("div", Object.assign({ className: 'item_right' }, { children: [_jsxs("div", Object.assign({ className: 'right_header' }, { children: [_jsx("div", Object.assign({ className: 'header_members' }, { children: _jsx(SlideSearchShareItemMembers, { members: members }) })), _jsx("div", Object.assign({ className: 'header_status' }, { children: _jsx(SlideSearchShareItemStatus, { members: members }) }))] })), _jsx(SlideSearchSlideItemFooter, { className: 'right_footer', count: count, createdAt: createdAt })] }))] })) })) }));
};
SlideSearchShareItem.propTypes = {
    className: propStr(),
    isNoLink: propBool(),
    item: propShape().isRequired,
    onClickNoLink: propFunc(),
};
SlideSearchShareItem.defaultProps = {
    className: '',
    isNoLink: false,
    onClickNoLink: undefined,
};
export default SlideSearchShareItem;
